import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap';
import { ProgramEmailModalComponent } from 'app/+campaign-library/email-modal/asset-email.modal.component';
import { CampaignService } from 'app/client-core/services';

@Component({
  selector: 'app-notify-button',
  templateUrl: './notify-button.component.html',
  styleUrls: ['./notify-button.component.scss']
})
export class NotifyButtonComponent implements OnInit {
  @Input() selectedProgram: number;

  constructor(
    private modalService: BsModalService,
    private campaignService: CampaignService
  ) { }

  ngOnInit() {
  }

  notify() {
    this.campaignService.notify.next(this.selectedProgram);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/notify-button/notify-button.component.ts